import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const RefundIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Refund`} {...props}>
    <G id="Icon/16px/Refund">
      <Path
        id="Ellipse 330"
        d="M3 8.5C3 11.5376 5.46243 14 8.5 14C11.5376 14 14 11.5376 14 8.5C14 5.46243 11.5376 3 8.5 3H6.5"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        id="Vector 210"
        d="M7.5 1L5.5 3L7.5 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  </Icon>
);

export default RefundIcon;
